import $ from 'jquery';
import { validateEmail } from './Utils';

class NewsletterSignUpController {
    static processEmail(email, path) {
        if (validateEmail(email)) {
            window.location = `${path}?email=${email}`;
        }
        else {
            document.querySelector('form').reportValidity();
        }
    }

    static newsletterSignupInit(container, inputId, path) {
        const button = $(container).children('.btn');
        $(`#${inputId}`).pressEnter((e) => {
            NewsletterSignUpController.processEmail(e.target.value, path);
        });

        $(button).click(() => {
            NewsletterSignUpController.processEmail($(`#${inputId}`).val(), path);
        });
    }
}

window.NewsletterSignUpController = NewsletterSignUpController;
export default NewsletterSignUpController;
